import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField
} from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Button from 'components/CustomButtons/Button';
import CustomDialogWithContact from 'components/CustomDialog/CustomDialogWithContact';
import CustomDialogWithProperty from 'components/CustomDialog/CustomDialogWithProperty';
import {
  comparisonOperatorLabels,
  gci_exception_conditions,
  isConditionAvailable
} from './GCIExceptionsLogic';

const styles = {
  radio: {
    color: '#9e9e9e',
    '&$radioChecked': {
      color: '#424242'
    }
  },
  radioChecked: {}
};

const getOptionValue = option => (
  option && typeof option === 'object' ? option.id : option
);

const getOptionLabel = option => (
  option && typeof option === 'object' ? option.label : option
);

class GCIConditionDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(props);
  }

  componentDidUpdate(prevProps) {
    if ((!prevProps.open && this.props.open) || prevProps.condition !== this.props.condition) {
      this.setState(this.getInitialState(this.props));
    }
  }

  getInitialState = props => {
    const condition = props.condition || {};
    return {
      filter: '',
      field: condition.field || '',
      operator: condition.operator || '',
      value: condition.value === undefined || condition.value === null ? '' : condition.value,
      contactPickerOpen: false,
      propertyPickerOpen: false
    };
  };

  chooseContact = contactData => {
    let contact = contactData;
    if (contact && contact.signers && contact.signers.length > 0) {
      contact = contact.signers[0];
    }
    if (!contact || !contact.id) return;

    const name = [contact.first_name || contact.name, contact.last_name]
      .filter(Boolean)
      .join(' ') || contact.company_name || `Contact ${contact.id}`;

    this.setState({ value: { id: contact.id, name }, contactPickerOpen: false });
  };

  chooseProperty = property => {
    if (!property || !property.id) return;

    const name = property.project_name
      || property.name
      || property.project_address
      || property.address
      || `Property ${property.id}`;

    this.setState({ value: { id: property.id, name }, propertyPickerOpen: false });
  };

  selectField = field => {
    const definition = gci_exception_conditions[field];
    this.setState({
      field,
      operator: definition && definition.operators.length ? definition.operators[0] : '',
      value: ''
    });
  };

  showConditionList = () => {
    this.setState({
      field: '',
      operator: '',
      value: ''
    });
  };

  renderValueInput = definition => {
    const { value, contactPickerOpen, propertyPickerOpen } = this.state;
    const { classes } = this.props;
    const options = definition.options || [];

    if (definition.element_type === 'property') {
      const selectedLabel = value && typeof value === 'object' ? value.name : '';
      return (
        <div style={{ marginTop: 20 }}>
          <Button color="primary" size="sm" onClick={() => this.setState({ propertyPickerOpen: true })}>
            <i className="fa fa-plus" style={{ marginRight: 8 }} />
            {selectedLabel ? 'Change' : 'Add'} Property
          </Button>
          {selectedLabel && (
            <span style={{ marginLeft: 12, fontSize: 16 }}>{selectedLabel}</span>
          )}
          {propertyPickerOpen && (
            <CustomDialogWithProperty
              open={true}
              close={() => this.setState({ propertyPickerOpen: false })}
              choose={this.chooseProperty}
              create_and_choose={this.chooseProperty}
              has_spaces={false}
              title="Search Existing Property"
              label="Search Existing Property"
            />
          )}
        </div>
      );
    }

    if (definition.element_type === 'associate' || definition.element_type === 'contact') {
      const isAssociate = definition.element_type === 'associate';
      const selectedLabel = value && typeof value === 'object' ? value.name : '';
      return (
        <div style={{ marginTop: 20 }}>
          <Button color="primary" size="sm" onClick={() => this.setState({ contactPickerOpen: true })}>
            <i className="fa fa-plus" style={{ marginRight: 8 }} />
            {selectedLabel ? 'Change' : 'Add'} {isAssociate ? 'Associate' : 'Contact'}
          </Button>
          {selectedLabel && (
            <span style={{ marginLeft: 12, fontSize: 16 }}>{selectedLabel}</span>
          )}
          {contactPickerOpen && (
            <CustomDialogWithContact
              open={true}
              close={() => this.setState({ contactPickerOpen: false })}
              choose={this.chooseContact}
              create_and_choose={this.chooseContact}
              peopleType={definition.people_type}
              title={isAssociate ? 'Select Associate' : `Select ${definition.label}`}
              label={isAssociate ? 'Search Associates' : 'Search Contacts'}
            />
          )}
        </div>
      );
    }

    if (definition.element_type === 'select') {
      return (
        <FormControl fullWidth style={{ marginTop: 20 }}>
          <InputLabel>Value</InputLabel>
          <Select value={value} onChange={e => this.setState({ value: e.target.value })}>
            {options.map(option => (
              <MenuItem key={String(getOptionValue(option))} value={getOptionValue(option)}>
                {getOptionLabel(option)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    if (definition.element_type === 'radio') {
      return (
        <FormControl component="fieldset" fullWidth style={{ marginTop: 25 }}>
          <FormLabel component="legend">Value</FormLabel>
          <RadioGroup value={String(value)} onChange={e => this.setState({ value: e.target.value })}>
            {options.map(option => (
              <FormControlLabel
                key={String(getOptionValue(option))}
                value={String(getOptionValue(option))}
                control={<Radio classes={{ root: classes.radio, checked: classes.radioChecked }} />}
                label={getOptionLabel(option)}
              />
            ))}
          </RadioGroup>
        </FormControl>
      );
    }

    return (
      <TextField
        fullWidth
        label="Value"
        margin="normal"
        value={value}
        onChange={e => this.setState({ value: e.target.value })}
      />
    );
  };

  render() {
    const { open, onClose, onSave, condition, conditions } = this.props;
    const { filter, field, operator, value } = this.state;
    const search = filter.trim().toLowerCase();
    const availableFields = Object.keys(gci_exception_conditions).filter(key => {
      const definition = gci_exception_conditions[key];
      const matchesSearch = !search
        || definition.label.toLowerCase().indexOf(search) !== -1
        || key.toLowerCase().indexOf(search) !== -1;
      return matchesSearch && isConditionAvailable(key, conditions);
    });
    const definition = field ? gci_exception_conditions[field] : null;
    const canSave = Boolean(definition && operator && value !== '');

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{condition ? 'Edit Condition' : 'Add Condition'}</DialogTitle>
        <DialogContent>
          {!definition && (
            <React.Fragment>
              <TextField
                autoFocus
                fullWidth
                label="Filter conditions"
                margin="normal"
                value={filter}
                onChange={e => this.setState({ filter: e.target.value })}
              />

              <List style={{ marginTop: 10 }}>
                {availableFields.map(key => (
                  <ListItem
                    button
                    divider
                    key={key}
                    onClick={() => this.selectField(key)}
                    style={{ cursor: 'pointer' }}
                  >
                    <ListItemText primary={gci_exception_conditions[key].label} />
                  </ListItem>
                ))}
                {availableFields.length === 0 && (
                  <ListItem>
                    <ListItemText primary="No conditions match your filter." />
                  </ListItem>
                )}
              </List>
            </React.Fragment>
          )}

          {definition && (
            <React.Fragment>
              <Button color="white" size="sm" onClick={this.showConditionList}>
                <ChevronLeft /> Back
              </Button>

              <div style={{ marginTop: 20 }}>
                <div style={{ color: '#777', fontSize: 12 }}>Field</div>
                <div style={{ fontSize: 18, fontWeight: 500, marginTop: 4 }}>
                  {definition.label}
                </div>
              </div>

              <FormControl fullWidth style={{ marginTop: 20 }}>
                <InputLabel>Operator</InputLabel>
                <Select value={operator} onChange={e => this.setState({ operator: e.target.value })}>
                  {definition.operators.map(item => (
                    <MenuItem key={item} value={item}>
                      {comparisonOperatorLabels[item] || item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {this.renderValueInput(definition)}
            </React.Fragment>
          )}
        </DialogContent>
        <DialogActions>
          <Button color="white" onClick={onClose}>Cancel</Button>
          {definition && (
            <Button
              color="primary"
              disabled={!canSave}
              onClick={() => onSave({ field, operator, value })}
            >
              {condition ? 'Update Condition' : 'Add Condition'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

GCIConditionDialog.defaultProps = {
  conditions: []
};

export default withStyles(styles)(GCIConditionDialog);
